// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__2cdRS","logo":"Navigation_logo__1gwgR","menu_lists":"Navigation_menu_lists__3AiJ7"};